// v109.9.91 — Shared daily-icon catalog used by Directory, Chat Bubble, and
// the Punch-In icon picker. Every user picks one of these icons on Punch-In
// each day; that icon is then rendered as their avatar across the app.
//
// Keep this list stable — the backend persists the icon by its string key.
// If you add a new icon, append it to the end (never reorder existing keys).

import {
  UserCircle2, Smile, Star, Heart, Zap, Rocket, Cloud, Feather,
  Flame, Leaf, Anchor, Compass, Coffee, Music, Moon, Sun,
} from "lucide-react";

export const ICON_MAP = {
  UserCircle2, Smile, Star, Heart, Zap, Rocket, Cloud, Feather,
  Flame, Leaf, Anchor, Compass, Coffee, Music, Moon, Sun,
};

export const ICON_LIST = Object.keys(ICON_MAP);

// Deterministic accent palette matching FloatingChatBubble / Directory.
export const LETTER_GLOWS = [
  { text: "text-indigo-500 dark:text-indigo-300",   glow: "rgba(129,140,248,0.75)" },
  { text: "text-emerald-500 dark:text-emerald-300", glow: "rgba(52,211,153,0.75)"   },
  { text: "text-rose-500 dark:text-rose-300",       glow: "rgba(251,113,133,0.75)"  },
  { text: "text-amber-500 dark:text-amber-300",     glow: "rgba(251,191,36,0.75)"   },
  { text: "text-violet-500 dark:text-violet-300",   glow: "rgba(196,181,253,0.75)"  },
  { text: "text-sky-500 dark:text-sky-300",         glow: "rgba(125,211,252,0.75)"  },
  { text: "text-teal-500 dark:text-teal-300",       glow: "rgba(94,234,212,0.75)"   },
  { text: "text-fuchsia-500 dark:text-fuchsia-300", glow: "rgba(240,171,252,0.75)"  },
];

// Returns { text, glow } accent based on the first char of the seed.
export function letterGlow(seed) {
  const s = String(seed || "?").toUpperCase().charCodeAt(0) || 65;
  return LETTER_GLOWS[(s - 65 + LETTER_GLOWS.length) % LETTER_GLOWS.length];
}

// Deterministic icon key from a name (used as fallback when the user has
// NOT picked a daily icon yet).
export function iconKeyForName(seed) {
  const raw = String(seed || "?");
  let sum = 0;
  for (let i = 0; i < raw.length; i += 1) sum += raw.charCodeAt(i);
  return ICON_LIST[sum % ICON_LIST.length];
}

// Resolve to the lucide component. `chosen` (e.g. from the daily-icons map)
// wins over the deterministic fallback so users see their own selection.
export function iconForUser({ chosen, name }) {
  if (chosen && ICON_MAP[chosen]) return ICON_MAP[chosen];
  return ICON_MAP[iconKeyForName(name)];
}
